'use client';

import React from 'react';
import Image from 'next/image';
import Typography from '@ui/Typography';
import useEditProfileStore from '@/components/store/editProfileModalSlice';
import useUserProfile from '@/hooks/useUserProfile';

function NotificationSettings(props) {
  const user = useUserProfile();
  const setIsOpen = useEditProfileStore((state) => state.setOpen);

  const handleToggleNotificationSettings = () => {
    setIsOpen(true, user, 'Notifications');
  };

  return (
    <div
      onClick={handleToggleNotificationSettings}
      className="flex items-center gap-4">
      <Image
        width={40}
        height={40}
        src="/assets/icons/my-nonprofit.svg"
        alt="my dashboard"
        className="h-10 w-10"
      />
      <Typography
        variant="h3"
        className="text-left hover:text-text-hyperlink hover:cursor-pointer">
        Notification Settings
      </Typography>
    </div>
  );
}

export default NotificationSettings;
